var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticStyle: { "margin-bottom": "40px" },
          attrs: { "align-h": "center" }
        },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "9" } },
            _vm._l(_vm.dataDonations, function(item) {
              return _c(
                "b-row",
                { key: item.id, staticClass: "mb-5" },
                [
                  _c("b-col", { attrs: { cols: "12", xl: "8" } }, [
                    _c(
                      "div",
                      { staticClass: "donation-list-item" },
                      [
                        _c(
                          "b-carousel",
                          {
                            attrs: {
                              id: "carousel-" + item.id,
                              interval: 4000,
                              fade: "",
                              controls: "",
                              background: "#ababab",
                              "img-width": "100%",
                              "img-height": "auto"
                            }
                          },
                          _vm._l(item.images, function(image, index) {
                            return _c("b-carousel-slide", {
                              key: index,
                              staticClass: "custom-image-slider",
                              attrs: { "img-src": image }
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("h2", { staticClass: "mt-4 text-left" }, [
                          _vm._v(_vm._s(item.name))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "text-left" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "12", xl: "4" } }, [
                    _c(
                      "div",
                      { staticClass: "box-total-donation d-flex flex-column" },
                      [
                        _c("h3", { staticClass: "mb-4" }, [
                          _vm._v("Donate to " + _vm._s(item.name))
                        ]),
                        _vm._v(" "),
                        _c("h2", { staticClass: "donation-dollar mb-1" }, [
                          _vm._v(
                            "$ " + _vm._s(_vm.formatPrice(item.total_donation))
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "d-inline-block text-left mb-4" },
                          [_vm._v("Total Donations")]
                        ),
                        _vm._v(" "),
                        !item.is_donate
                          ? _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { href: "/#/donations?_d=" + item.id }
                              },
                              [_vm._v("Donate Now")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.is_donate
                          ? _c(
                              "div",
                              { staticClass: "d-flex flex-column text-left" },
                              [
                                _c("h4", { staticClass: "is-donate" }, [
                                  _vm._v("You donated to this mission")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-inline-block mb-1 text-muted"
                                  },
                                  [
                                    _vm._v(
                                      "Next Donation " +
                                        _vm._s(item.next_donation)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "cursor-pointer text-muted",
                                    on: {
                                      click: function($event) {
                                        return _vm.cancelDonation(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v("Cancel Donation")]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3354544e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3354544e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DonationLists.vue
// module id = null
// module chunks = 